export enum AlertType {
	Info = 'info',
	Error = 'error',
	Warning = 'warning',
	Success = 'success',
}

export class Alert {

	private _namespace: string = null;
	private _alertType: AlertType;
	private _title: string = null;
	private _message: string = null;
	private _error: any = null;
	private _timeout = 0;
	private _id: string;

	constructor(alertObject: any) {
		this._namespace = alertObject.namespace;
		this._alertType = alertObject.alertType;
		this._title = alertObject.title;
		this._message = alertObject.message;
		this._error = alertObject.error;
		this._timeout = alertObject.timeout;
	}

	get namespace(): string {
		return this._namespace;
	}

	set namespace(newNamespace: string) {
		this._namespace = newNamespace;
	}

	get alertType(): AlertType {
		return this._alertType;
	}

	set alertType(newAlertType: AlertType) {
		this._alertType = newAlertType;
	}

	get id(): string {
		return this._id;
	}

	set id(newValue: string) {
		this._id = newValue;
	}

	get title(): string {
		return this._title;
	}

	set title(newTitle: string) {
		this._title = newTitle;
	}

	get message(): string {
		return this._message;
	}

	set message(newMessage: string) {
		this._message = newMessage;
	}

	get error(): any {
		return this._error;
	}

	set error(newError: any) {
		this._error = newError;
	}

	get timeout(): number {
		return this._timeout;
	}

	set timeout(newTimeout: number) {
		this._timeout = newTimeout;
	}

	isInfo(): boolean {
		return this.alertType === AlertType.Info;
	}

	isError(): boolean {
		return this.alertType === AlertType.Error;
	}

	isWarning(): boolean {
		return this.alertType === AlertType.Warning;
	}

	isAllGood(): boolean {
		return this.alertType === AlertType.Success;
	}
}
